import { useEffect, useRef, isValidElement } from 'react';
import style from './Offcanvas.module.scss'
import useOutsideAlerter from 'helpers/useOutsideAlerter';
import { FaTimes } from 'react-icons/fa';

const Offcanvas = ({ show, content, onClose, sticky }) => {
    const drawerRef = useRef();
    const stickyRef = useRef();

    const close = () => {
        if (stickyRef.current !== true) {
            if (onClose) {
                onClose();
            }
        }
    }

    const getContentProp = (prop) => {
        const type = typeof content[ prop ];
        return type === 'function' ? content[ prop ]() : content[ prop ];
    }

    useOutsideAlerter(drawerRef, () => {
        close()
    })

    useEffect(() => {
        stickyRef.current = sticky;
    }, [ sticky ])

    return (
        <>
            <div className={ `${style.overlay} ${show && style.show}` }>
                <div ref={ drawerRef } className={ style.drawer }>
                    <button className={ style.close } onClick={ (e) => {
                        close()
                    } }>
                        <FaTimes />
                    </button>
                    { content !== undefined && <>
                        { isValidElement(content) ? <div className={ style.drawerContent }>{ content }</div> : <>
                            <div className={ style.drawerTitle }>{ getContentProp('title') }</div>
                            <div className={ style.drawerBody }>{ getContentProp('content') }</div>
                            <div className={ style.drawerFooter }>{ getContentProp('footer') }</div>
                        </> }
                    </> }
                </div>
            </div>
        </>
    )
}

export default Offcanvas;